<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Configuración de documentos</h4>
            </vs-col>
            <vs-col sm="12" lg="2" class="ml-auto">
                <vs-button
                    success
                    class="ml-auto"
                    @click="activeModal('crear')"
                >
                    <i class="fas fa-plus mr-2"></i>Crear documento
                </vs-button>
            </vs-col>
            <vs-col sm="12" lg="2">
                <vs-button
                    warn
                    class="ml-auto"
                    @click="activeModal('subir')"
                >
                    <i class="fas fa-file mr-2"></i>Subir documento
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row>
            
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar"  :disabled="!ciclosEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="ciclosEscolares.length" autocomplete="off">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Nombre
                    </label>
                    <vs-input class="pt-0" v-model="nombre" placeholder="Nombre" />
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getConfiguracionDocumentos()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <div class="mt-5">
            <div class="d-flex mb-5">
                <div  @click="getCambioPestana('personalizados')" :class="estilosCambio == 'personalizados' ? 'estilosActivos' : 'estilosNoActivos'">
                    <h5>Documentos personalizados</h5>
                </div>
                <div  @click="getCambioPestana('externo')" :class="estilosCambio == 'externo' ? 'estilosActivos' : 'estilosNoActivos'">
                    <h5>Documentos externos</h5>
                </div>
            </div>
        </div>
        <div v-show="botonPersonalizado">
           <!-- <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar"  :disabled="!ciclosEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="ciclosEscolares.length" autocomplete="off">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Nombre
                    </label>
                    <vs-input class="pt-0" v-model="nombre" placeholder="Nombre" />
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getConfiguracionDocumentos()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
            </vs-row> -->
            <documentos :documentos="documentos" :instituciones="instituciones" @refreshTable="getConfiguracionDocumentos" :tipoModal="tipoModal"></documentos> 
        </div>
        <div v-show="botonExterno">
            <documentos-externo :documentos="documentosExternos" :instituciones="instituciones" @refreshTable="getConfiguracionDocumentos" :tipoModal="tipoModal"></documentos-externo> 
        </div>
        
        <crear v-model="activeCrear" :instituciones="instituciones" @refreshTable="getConfiguracionDocumentos" :tipoModal="tipoModal"></crear>
        <archivo-externo v-model="activeExterno" :instituciones="instituciones" @refreshTable="getConfiguracionDocumentos"></archivo-externo>
    </div>
</template>

<script>
import configuracion from '../../../../api/requests/configuracion'
import documentos from './tabla-documentos.vue'
import DocumentosExterno from './tabla-documentos-externo.vue'
import crear from './modales/crear.vue'
import ArchivoExterno from './modales/externo.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            nombre: '',
            documentos: [],
            documentosExternos: [],
            errorFields: [],
            activeCrear: false,
            activeExterno: false,
            
            estilosCambio: 'personalizados',
            botonPersonalizado: true,
            botonExterno: false,
            tipoModal: ''
        }
    },
    created(){
        this.getInstituciones()
    },
    components:{
        documentos,
        crear,
        ArchivoExterno,
        DocumentosExterno
    },
    methods:{
        activeModal(tipo){
            console.log("entro aqui ")
            this.activeCrear=!this.activeCrear
            if(tipo == 'crear'){
                this.tipoModal = 'crear'
            }
            if(tipo == 'subir'){
                this.tipoModal = 'subir'
            }
        },
        getCambioPestana(boton){
            if(boton == 'personalizados'){
                this.botonPersonalizado = true,
                this.botonExterno = false
                this.estilosCambio = 'personalizados'
            }

            if(boton == 'externo'){
                this.botonExterno = true
                this.botonPersonalizado = false
                this.estilosCambio = 'externo'
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await configuracion.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await configuracion.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getConfiguracionDocumentos(){
            const params = this.sanityForm()
            if(params){
                try {
                    const loading = this.$vs.loading()
                    const { data: response } = await configuracion.getConfiguracionDocumentos(params)
                    loading.close()
                    this.documentos = response.data
                    this.documentosExternos = response.data
                }
                catch{
                    
                }
            }
        },
        async getConfiguracionDocumentosExternos(){
            const params = this.sanityForm()
            if(params){
                try {
                    const loading = this.$vs.loading()
                    const { data: response } = await configuracion.getConfiguracionDocumentos(params)
                    loading.close()
                    this.documentosExternos = response.data
                }
                catch{
                    
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if(this.botonExterno == true){
                if (!this.cicloEscolar) {
                    this.errorFields.push('cicloEscolar')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    texto: this.nombre,
                    page: 1
                }
                if(this.botonExterno == true){
                    params.ciclo_escolar_id = this.cicloEscolar
                }
                return params
            } else {
                return null
            }
        },
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
        }
    }
}
</script>


<style scoped>
.estilosActivos{
    color:#2471A3;
    border-bottom: 2px solid #2471A3;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
.estilosNoActivos{
    color:#CACFD2;
    font-weight: bold;
    margin: 0 1%;
    cursor: pointer;
}
</style>